import { useState, useMemo } from "react";

import editIcon from "../../../../../../Assets/images/edit-icon.svg";
import deleteIcon from "../../../../../../Assets/images/delete-icon.svg";

import moment from "moment/moment";
import { DATE_FORMAT } from '../../../Utils/Constants';

const TruckList = ({ trucks, onEdit, onView, onDelete }) => {
    const [selected, setSelected] = useState([]);

    const [trucksPerPage, setTrucksPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const totalTrucks = trucks.length;
    const totalPages = Math.ceil(totalTrucks / trucksPerPage);
    const startIndex = (currentPage - 1) * trucksPerPage;

    const currentTrucks = useMemo(
        () => trucks.slice(startIndex, startIndex + trucksPerPage),
        [trucks, startIndex, trucksPerPage]
    );

    const allSelected = currentTrucks.length > 0 && currentTrucks.every((row) => selected.includes(row.truck_id));

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="table-cvr">
            <div className="table-inner">
                <table id="roleTable" className="table">
                    <thead>
                        <tr>
                            <th className="text-middle">#</th>
                            <th>Truck ID</th>
                            <th>Vehicle No</th>
                            <th>License Plate No</th>
                            <th>Insurance No.</th>
                            <th>Truck Type</th>
                            <th>Created</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentTrucks.length > 0 ? (
                            currentTrucks.map((row, i) => (
                                <tr key={row.truck_id}>
                                    <td className="text-middle">{startIndex + i + 1}</td>
                                    <td>
                                        <a className="vu-link" style={{ cursor: "pointer" }} onClick={() => {
                                            console.log('=== TRUCK CLICKED ===');
                                            console.log('truck_id:', row.truck_id);
                                            console.log('onView function:', onView);
                                            onView(row.truck_id);
                                        }}>
                                            T-{row.truck_id}
                                        </a>
                                    </td>
                                    <td>{row.vehicle_no}</td>
                                    <td>{row.license_plate_no}</td>
                                    <td>{row.insurance_no}</td>
                                    <td>
                                        <p className="lc-no">{row.truck_type}</p>
                                    </td>
                                    <td>
                                        {row.last_upated_datetime
                                            ? moment(row.last_upated_datetime).local().format(DATE_FORMAT)
                                            : "-"}
                                    </td>
                                    <td className="edit-col">
                                        <a href="#" onClick={() => onEdit(row)}>
                                            <img className="tb-icon" src={editIcon} alt="Edit" />
                                        </a>
                                    </td>
                                    <td>
                                        <a href="#" onClick={() => onDelete(row)}>
                                            <img className="ct-icon" src={deleteIcon} alt="Delete" />
                                        </a>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center py-4 text-muted">
                                    No Trucks Found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="dt-layout-row d-flex align-items-center justify-content-between mt-3">
                <div className="dt-length">
                    Showing{" "}
                    <select className="dt-input" value={trucksPerPage} onChange={(e) => { setCurrentPage(1); setTrucksPerPage(Number(e.target.value)); }} >
                        {[5, 10, 50, 100].map((n) => (
                            <option key={n} value={n}>
                                {n}
                            </option>
                        ))}
                    </select>{" "}
                    of {totalTrucks} entries
                </div>

                <div className="dt-paging d-flex align-items-center" style={{ gap: "5px" }}>
                    <button className="dt-paging-button previous" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }).map((_, i) => (
                        <button key={i + 1} className={`dt-paging-button ${currentPage === i + 1 ? "current" : ""}`} onClick={() => handlePageChange(i + 1)} >
                            {i + 1}
                        </button>
                    ))}
                    <button className="dt-paging-button next" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}  >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TruckList;